module.exports = {"object":"value","document":{"object":"document","nodes":[{"object":"block","type":"paragraph","nodes":[{"object":"text","text":"Try mentioning some users, like Luke or Leia."}]}]}}


//////////////////
// WEBPACK FOOTER
// ./examples/mentions/value.json
// module id = 1774
// module chunks = 0